import * as React from 'react';
import { v4 as uuidV4 } from 'uuid';

interface SessionIdProviderProps {
  children: React.ReactNode;
}

const SESSION_ID_KEY = 'zid';

const getSessionId = () => {
  if (typeof window !== 'undefined') {
    return sessionStorage.getItem(SESSION_ID_KEY);
  }
  return 'not available';
};

function SessionIdProvider({ children }: SessionIdProviderProps) {
  React.useEffect(() => {
    if (!sessionStorage.getItem(SESSION_ID_KEY)) {
      // TODO: In future, check for a query string that may pass this id from a redirecting app
      const sessionId = uuidV4();
      sessionStorage.setItem(SESSION_ID_KEY, sessionId);
    }
  }, []);

  return <>{children}</>;
}

export { SessionIdProvider, getSessionId };
